import { env } from '@repo/env';

// Okres promocyjny jest domyślnie wybrany tylko przy aktywnej ofercie specjalnej
// i gdy VITE_PRAGMA_PROMOTION_TENOR_DEFAULT_CHOOSE nie jest ustawione na 'false'.
// Brak zmiennej zachowuje dotychczasowe zachowanie (okres promocyjny wybrany).
export const shouldPreselectPromotionTenor = (isSpecialOffer: boolean) =>
  isSpecialOffer &&
  Boolean(env.VITE_PRAGMA_PROMOTION_TENOR) &&
  env.VITE_PRAGMA_PROMOTION_TENOR_DEFAULT_CHOOSE !== 'false';
